import { render, staticRenderFns } from "./OpenList.vue?vue&type=template&id=64363268&"
import script from "./OpenList.vue?vue&type=script&lang=js&"
export * from "./OpenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports